module.exports = __webpack_public_path__ + "img/photosession_1_3.ccf39e88.jpg";